<template>
  <el-drawer
    custom-class="drawer-custom-class"
    append-to-body
    :close-on-press-escape="false"
    title="报废处理"
    size="640px"
    :visible.sync="visible"
    direction="rtl"
    @closed="onClosed">
    <div
      v-loading="loading"
      class="drawer-wrap">
      <el-form
        label-width="85px"
        @submit.native.prevent>
        <el-row
          :gutter="8"
          type="flex">
          <el-col :span="24">
            <el-form-item label-width="0">
              <el-button
                type="primary"
                @click="fetchList">刷新</el-button>

              <el-button
                type="primary"
                :disabled="multipleSelection.length === 0"
                @click="scrapSelected">批量报废(已勾选{{ multipleSelection.length }}条)</el-button>

              <el-button
                type="primary"
                @click="customScrap">自定义报废</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        border
        :data="list"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          fixed="left"
          width="40">
        </el-table-column>
        <el-table-column
          label="开始序号"
          min-width="180"
          prop="formatedBeginTagNo"> </el-table-column>
        <el-table-column
          label="结束序号"
          min-width="180"
          prop="formatedEndTagNo"> </el-table-column>
        <el-table-column
          label="发放数量"
          width="90"
          prop="tagCount"></el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="80">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="scraptags(row)">立即报废</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <apply-tag-invalid-modal
      ref="applyTagInvalidModal"
      @fetch="fetchList" />
  </el-drawer>
</template>

<script>
import AppraiseLable from '@/service/appraiseLable'
import ApplyTagInvalidModal from './apply-tag-invalid-modal.vue'

export default {
  name: 'LabelScrapModal',
  components: { ApplyTagInvalidModal },
  data() {
    return {
      visible: false,
      loading: false,
      config: { tagSegId: null },
      options: { max: 0, min: 0 },
      list: [],
      multipleSelection: []
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    onClosed() {
      this.config = { ...this.config, ...this.$options.data().config }
      this.list = []
    },
    batchScrap(list) {
      this.$confirm('是否立即报废?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          const tagSegs = list.map(item => ({ beginTagNo: item.beginTagNo, endTagNo: item.endTagNo }))
          AppraiseLable.scraptags({ ...this.config, tagSegs })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success('报废成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    scrapSelected() {
      this.batchScrap(this.multipleSelection)
    },
    scraptags(row) {
      this.batchScrap([row])
    },
    customScrap() {
      const { tagSegId } = this.config
      const { min, max } = this.options
      this.$refs.applyTagInvalidModal.init({ tagSegId, min, max })
    },
    fetchList() {
      this.loading = true
      AppraiseLable.getnotusedtags({ ...this.config })
        .then(res => {
          this.loading = false
          const { result, message, data } = res.data
          if ([0, 13].includes(result)) {
            this.list = data
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    fetch(row, options = {}) {
      this.visible = true
      this.config = { ...this.config, ...row }
      this.options = { ...this.options, ...options }
      this.fetchList()
    }
  }
}
</script>
